<template>
  <div>
    <section id="guie" class="hero-section">
      <div class="view-content">
        <div class="columns is-desktop align-items-center position-relative">
          <div class="column" style="margin-left: 3%;">
            <div class="hero-content">
              <h1>Clima Laboral</h1>
              <p>
                Al interactuar en un ambiente de trabajo, las personas comparten
                percepciones, ideas y creencias acerca de la organización y de
                la labor que se realiza. Esto se conoce como Clima
                Organizacional.
              </p>
              <a
                v-on:click="continueToTable"
                class="main-btn border-btn btn-hover"
                >Continuar a los resultados</a
              >
              <a
                :href="urlGuia"
                download="CL7+Guía de Interpretación 2024.pdf"
                class="main-btn border-btn btn-hover"
              >
                <div class="btn-text-icon">
                  Guía
                  <i class="material-icons">cloud_download</i>
                </div>
              </a>
              <a href="#features" class="scroll-bottom">
                <i class="material-icons">arrow_downward</i>
              </a>
            </div>
          </div>
          <div class="column">
            <div class="hero-img">
              <img
                src="@/assets/imgGuiaInterCL7.png"
                width="500"
                height="auto"
                alt="guide"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="features" class="feature-section">
      <div class="view-content">
        <div class="is-flex flex-wrap justify-content-center">
          <div class="w-full">
            <div class="single-feature">
              <div class="icon">
                <i class="material-icons">ac_unit</i>
              </div>
              <div class="content">
                <h3>¿Por qué es importante?</h3>
                <p>
                  Lo que las personas piensan acerca del lugar donde trabajan y
                  su labor determina en gran medida cómo se sienten y cómo se
                  comportan. Cuando el clima es positivo se fortalece el vínculo
                  con la organización, se disfruta más lo que se hace y se
                  logran mejores resultados.
                </p>
              </div>
            </div>
          </div>
          <div class="w-full">
            <div class="single-feature">
              <div class="icon">
                <i class="material-icons">stars</i>
              </div>
              <div class="content">
                <h3>¿Qué evalúa este diagnóstico?</h3>
                <p>
                  Nuestro modelo surge del análisis riguroso de la literatura
                  sobre clima organizacional, y se complementa con el modelo de
                  cultura de Cameron & Quinn (Competing values framework). Este
                  diagnóstico incluye las dimensiones centrales: Liderazgo,
                  Compensación, Recursos y Engagement, y cuatro cuadrantes:
                  Apoyo, Calidad, Innovación y Metas con sus respectivas
                  subdimensiones. Los cuadrantes representan los aspectos
                  favorables de cada uno de los tipos de cultura definidos por
                  los autores mencionados: Clan, Jerárquica, Adhocrática y
                  Mercado.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import archivoPDF from "@/assets/files/guia_interpretacion_cl7_2024.pdf";

export default {
  data() {
    return {
      urlGuia: archivoPDF,
    };
  },
  props: {
    proceso: {
      Object,
    },
  },
  computed: {
    ...mapState(["empresa", "idtoken", "isOculto"]),
  },
  methods: {
    continueToTable() {
      this.$emit("selectSection", { d: "yResultado", name: "Resultados" });
    },
    scrollTop() {
      const el = document.getElementById("guie");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  beforeMount() {
    if (!this.isOculto) {
      this.$store.commit("ocultarSide");
    }
  },
  mounted() {
    this.scrollTop();
  },
};
</script>

<style scoped lang="scss">
#guie {
  margin-top: 10px;
}

.title-card {
  border-radius: 10px !important;
  background-color: #f3f3f3 !important;
}

.hero-section {
  position: relative;
  z-index: 1;
  padding: 100px 0 140px;
  @media (max-width: 640px) {
    padding: 25px 20px 51px !important;
  }
  background-image: url("~@/assets/hero-bg.svg");
  background-position: top center;
  background-repeat: no-repeat;
}

.align-items-center {
  align-items: center !important;
}

.position-relative {
  position: relative !important;
}

.hero-section .hero-content {
  margin-bottom: 100px;
}

.hero-section .hero-content h1 {
  font-size: 60px;
  font-weight: bolder;
  margin-bottom: 35px;
  color: #fff;
  @media (max-width: 640px) {
    font-size: 40px !important;
  }
}

.hero-section .hero-content strong {
  color: #fff;
}

.hero-section .hero-content p {
  margin-bottom: 40px;
  font-size: 18px;
  line-height: 28px;
  color: #fff;
}

.hero-section .hero-content .scroll-bottom {
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  border: 3px solid #9246df;
  color: #9246df;
  left: 15px;
  bottom: 0;
  z-index: 9;
}

.hero-section .hero-content .scroll-bottom i {
  font-weight: 700;
  margin-left: 5px;
  margin-top: 5px;
}

.hero-section .hero-content .scroll-bottom {
  margin-left: 2%;
  margin-bottom: 2%;
}

.hero-section .hero-img {
  margin-left: 10% !important;
  @media only screen and (max-width: 1024px) {
    display: flex;
    justify-content: center;
  }
}

.hero-section .hero-img img {
  border-radius: 2% !important;
}

.hero-section .hero-content .main-btn {
  border-color: #9246df;
  color: #9246df;
}

.main-btn.border-btn {
  border: 2px solid #9246df;
  background: white;
  color: #9246df;
}

.btn-hover {
  position: relative;
  overflow: hidden;
}

.main-btn {
  display: inline-block;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding: 13px 33px;
  font-size: 18px;
  border-radius: 50px;
  color: #fff;
  cursor: pointer;
  z-index: 5;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  border: none;
  background: #9246df;
  overflow: hidden;
}

.main-btn:hover {
  border-color: white !important;
  background: #9346df89 !important;
  color: white !important;
}

a:hover {
  text-decoration: none;
}

.btn-text-icon {
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.btn-text-icon i {
  margin-left: 5px;
}

// features

@media only screen and (max-width: 1024px) {
  .flex-wrap {
    flex-wrap: wrap;
  }
}

.justify-content-center {
  justify-content: center !important;
}

@media only screen and (min-width: 1400px) {
  .feature-section .single-feature {
    padding: 30px 40px;
  }
}

.feature-section .single-feature .icon {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background: #9346df1a;
  color: #9246df;
  margin: auto;
  margin-bottom: 30px;
  font-size: 65px;
  line-height: 1;
}

.feature-section .single-feature .icon i {
  font-size: 65px;
  line-height: 1;
}

.feature-section .single-feature {
  width: 95%;
  margin: auto;
  text-align: center;
  padding: 30px 10px;
}

.feature-section .single-feature .content h3 {
  margin-bottom: 20px;
}

.feature-section .single-feature .content p {
  font-size: 18px;
  line-height: 28px;
}

.w-full {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/GuiaInterpretacion.vue